function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartialTruck1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.01,
    height: 22.808,
    viewBox: "0 0 30.01 22.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23572"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5294",
    d: "M7.5 0h22.51v15.308a7.5 7.5 0 0 1-7.5 7.5H0V7.5A7.5 7.5 0 0 1 7.5 0z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23571"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18865",
    d: "m20.162 110.542-.094-.123a12.159 12.159 0 0 1-.948-1.544 7.588 7.588 0 0 0-.782-1.253 2.419 2.419 0 0 0-1.739-1.044H12.753a.713.713 0 0 0-.691.538v6.196a.236.236 0 0 1-.062.168.576.576 0 0 1-.427.128H.695a.676.676 0 0 0-.695.653v2.246a.676.676 0 0 0 .695.653h2.39a2.8 2.8 0 0 0 5.584 0h4a2.8 2.8 0 0 0 5.584 0h1.817a1.251 1.251 0 0 0 1.25-1.25v-2.14a4.785 4.785 0 0 0-1.158-3.228zm-3.657 6.375a1.045 1.045 0 1 1-1.045-1.045 1.046 1.046 0 0 1 1.045 1.045zm2.4-5.441c-.022.036-.084.052-.179.046h-4.8V107.6H16a1.566 1.566 0 0 1 1.366.839c.274.4 1 1.645 1.036 1.709l.079.151c.214.401.53 1.009.428 1.178zm-13.033 4.4a1.045 1.045 0 1 1-1.045 1.045 1.046 1.046 0 0 1 1.049-1.049z",
    transform: "translate(4.504 -100.517)",
    style: {
      fill: "#1b74e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18866",
    d: "M18.342 160.09h3.31a.62.62 0 0 0 .608-.629v-2.515a.62.62 0 0 0-.608-.629h-3.31a.62.62 0 0 0-.608.629v2.515a.62.62 0 0 0 .608.629z",
    transform: "translate(-12.189 -147.902)",
    style: {
      fill: "#1b74e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18867",
    d: "M131.342 160.09h3.31a.62.62 0 0 0 .608-.629v-2.515a.62.62 0 0 0-.608-.629h-3.31a.62.62 0 0 0-.608.629v2.515a.62.62 0 0 0 .608.629z",
    transform: "translate(-119.784 -147.902)",
    style: {
      fill: "#1b74e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18868",
    d: "M18.342 66.09h3.31a.62.62 0 0 0 .608-.629v-2.515a.62.62 0 0 0-.608-.629h-3.31a.62.62 0 0 0-.608.629v2.515a.62.62 0 0 0 .608.629z",
    transform: "translate(-12.189 -58.399)",
    style: {
      fill: "#1b74e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18869",
    d: "M131.342 66.09h3.31a.62.62 0 0 0 .608-.629v-2.515a.62.62 0 0 0-.608-.629h-3.31a.62.62 0 0 0-.608.629v2.515a.62.62 0 0 0 .608.629z",
    transform: "translate(-119.784 -58.399)",
    style: {
      fill: "#1b74e4"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialTruck1);
export default __webpack_public_path__ + "static/media/partial_truck_1.4dc6683989570544dd3a82f35398dbb9.svg";
export { ForwardRef as ReactComponent };